import { render, staticRenderFns } from "./ManagePromotionDetail.vue?vue&type=template&id=b7a6e582"
import script from "./ManagePromotionDetail.vue?vue&type=script&lang=js"
export * from "./ManagePromotionDetail.vue?vue&type=script&lang=js"
import style0 from "./ManagePromotionDetail.vue?vue&type=style&index=0&id=b7a6e582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports